import React from "react";
import Footer from "../../../components/Footer";

const RetailHospitality = () => {
  return (
    <section className="bg-white pt-20">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* LEFT CONTENT */}
        <div className="px-6 sm:px-10 lg:px-16 py-12 lg:flex lg:items-center">
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-3">
              Industries →
            </p>

            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Cybersecurity for Retail & Hospitality
            </h1>

            <p className="font-semibold text-gray-800 mb-6">
              Retail and hospitality businesses are rapidly adopting digital
              technologies to enhance customer experience, streamline
              operations, and remain competitive across an increasingly digital
              marketplace.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              From point-of-sale systems and mobile apps to e-commerce platforms
              and loyalty programs, digital touchpoints now sit at the core of
              customer engagement—collecting and processing large volumes of
              sensitive customer data.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              Payment card details, personal information, booking data, and
              behavioral insights must be protected not only to meet compliance
              requirements, but to maintain customer trust and brand reputation.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              Retail and hospitality environments are frequent targets for
              cybercriminals due to high transaction volumes, distributed
              locations, and always-on operations where even short disruptions
              can impact revenue and customer experience.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              How can Synthera help?
            </h3>

            <ul className="space-y-4 mb-8">
              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Phishing-Resistant Identity Security:</strong> We
                  implement phishing-resistant MFA and identity protection so a
                  single compromised employee account cannot expose critical
                  systems or customer data.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>POS & Payment Network Segmentation:</strong> We secure
                  payment environments with strict network segmentation,
                  ensuring breaches in back-office systems cannot reach POS
                  terminals or payment gateways.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>API & E-commerce Hardening:</strong> We protect online
                  platforms with advanced web and API security, blocking
                  malicious bots, preventing data theft, and securing
                  integrations across partners and platforms.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>24/7 Threat Detection & Response:</strong> Our
                  continuous monitoring detects unusual behavior such as
                  suspicious logins or abnormal data access—allowing rapid
                  containment before it impacts operations or customers.
                </p>
              </li>
            </ul>

            <p className="text-gray-700 font-semibold mb-8">
              Our commitment is to secure the digital foundation of your
              business—protecting your data, your customers, and your brand—so
              you can focus on delivering exceptional service and experiences.
            </p>

            {/* COOL LINK CTA */}
            <a
              href="/Contact"
              className="group inline-flex items-center gap-1 font-semibold text-green-700 hover:text-green-800 transition"
            >
              <span className="relative">
                Talk to an expert
                <span className="absolute left-0 -bottom-0.5 h-0.5 w-0 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </span>
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative hidden lg:block pt-10">
          <img
            src="https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1770613372/Retail_and_hospitality_k2hyoz.png"
            alt="Retail and Hospitality Cyber Security"
            className="w-full h-full object-cover"
          />

          {/* GREEN OVERLAY (MATCHED WITH IMAGE OFFSET) */}
          {/* <div className="absolute top-10 left-0 right-0 bottom-0 bg-green-900/70"></div> */}
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default RetailHospitality;
